import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityNewBackService } from '@pages/authentication/services/securityNewBack.service';
import { CryptDataService } from '@shared/utils/crypt-data.service';
import { PermissionsService } from '@shared/utils/permissions/permissions.service';
import { BrowserStorageService } from '@shared/utils/browser-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  logo = environment.logo;
  logoWidth = environment.logoWidth;
  constructor(private permissionService: PermissionsService, private securityNBService: SecurityNewBackService, private _cryptService: CryptDataService, private router: Router, private storage: BrowserStorageService) {}

  ngOnInit() {
    // Usar el nuevo método que verifica y recupera el rol automáticamente
    this.permissionService.loadPermissionsWithRecovery().then(() => {
      const rol = this.storage.getSession('p9sh2');
      if (!rol || rol === '0') {
        this.router.navigateByUrl('/sesion-expirada');
      }
    }).catch((error) => {
      console.error('Error al cargar permisos:', error);
      this.router.navigateByUrl('/sesion-expirada');
    });

    this.securityNBService.getNewBackendToken().subscribe({
      next: (res) => {
        if (res.success) {
          this.storage.setSession('TokenNewBack', JSON.stringify(res.token));
          this._cryptService.encryptDataSessionAES('TokenNBTime', JSON.stringify(7200), true);
        } else {
          this.router.navigateByUrl('/sesion-expirada');
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
  }
}
